<template>
  <div>
    <v-app-bar
      class="bgc-mainnav"
      color="#333"
    >

      <v-toolbar-title><router-link class="c-white:h fz36 fz24@md c-white tdn logo" to="/">Gooch.me</router-link></v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn
        to="/blog"
        text
      >
        <span class="fOswald mr-2 navt">Blog</span>
      </v-btn>
      <v-btn
        to="/contact"
        text
      >
        <span class="fOswald mr-2 navt">Contact</span>
      </v-btn>
    </v-app-bar>
  </div>
</template>

<style>
  .fOswald {
    font-family: Oswald,Haas Grot Text R Web,Helvetica Neue,Helvetica,Arial,sans-serif;
  }
  .fz14 {
      font-size: 14px;
  }
  .bgc-mainnav {
    background-color: #333;
  }
  .logo {
    font-family:'Bungee Shade';
    color: white !important;
    text-decoration: none;
  }
  .navt{
    color: #999;
  }
  .navt:hover{
    color: #fb8c00;
  }
</style>

<script>
  export default {
    data: () => ({
      Links: [
        {
          text: 'Documentation',
          href: 'https://vuetifyjs.com',
        },
        {
          text: 'Chat',
          href: 'https://community.vuetifyjs.com',
        },
      ],
    }),
  }
</script>